import React from 'react';
import { Link } from 'react-router-dom';
import { Icon as NewIcon } from '@bb/elements-web';
import Icon from '../Icon';
import { Text } from '../Typography';
import { StyledHeaderItem } from './StyledComponents';

type FilesProps = {
  iconSizes: {
    width: number;
    height: number;
  };
  isMobile: boolean;
  closeMobileMenu: () => void;
  $height: number;
  showingsFeatureOn?: boolean;
};

const Files: React.FC<FilesProps> = ({
  iconSizes,
  isMobile,
  closeMobileMenu,
  $height,
  showingsFeatureOn,
}) => (
  <StyledHeaderItem
    $height={$height}
    $isMobile={isMobile}
    $showBackgroundColor
    as={Link}
    to="/assets"
    className="app-header-button"
    onClick={closeMobileMenu}
    $hasShowingsMadeEasyFeature={showingsFeatureOn}
  >
    {showingsFeatureOn ? (
      <NewIcon
        icon="folderFilled"
        color={isMobile ? 'default' : 'white'}
        size={24}
      />
    ) : (
      <Icon type="folder" {...iconSizes} offset={[0, -3]} />
    )}
    {isMobile && (
      <>
        <Text type="secondary">Files</Text>
        <div />
      </>
    )}
  </StyledHeaderItem>
);

export default Files;
